/**
 * LaborSection - Labor hours and rate input
 *
 * Wraps the existing LaborInput component for consistent styling
 */

import { useTranslation } from "react-i18next";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { LaborInput } from "@/components/quotes/LaborInput";
import { QuoteFormData, TemplateFormData } from "../index";

interface LaborSectionProps {
  form: UseFormReturn<QuoteFormData | TemplateFormData>;
}

export const LaborSection: React.FC<LaborSectionProps> = ({ form }) => {
  const { t } = useTranslation();
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">{t("features.quotes.quoteEditor.sections.laborSection.labor")}</h3>
      <LaborInput
        laborHours={form.watch("laborHours") ?? 0}
        onLaborHoursChange={(value) =>
          form.setValue("laborHours", value ?? 0, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
        laborRate={form.watch("laborRate") ?? 0}
        onLaborRateChange={(value) =>
          form.setValue("laborRate", value, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }
      />
    </div>
  );
};
